import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import ProjectGateway from '~apis/project';

export default function* watchGetProjectFilters(api: ProjectGateway): SagaWatcherReturnType {
    yield takeEvery('project/projectGetProjectFiltersAttempt', handleGetProjectFilters, api);
}

function* handleGetProjectFilters(api: ProjectGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;

    const response = yield* call([api, api.getProjectFilters], {
        authToken,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.projectGetProjectFiltersFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.projectGetProjectFiltersSuccess(response.data));
    }
}
